import type { CustomFieldFormValue, CustomFieldType, ProfileFieldValue } from '@/lib/contacts/types'

export function compactCustomFieldValues(values: Record<string, CustomFieldFormValue>) {
  return Object.fromEntries(
    Object.entries(values).filter(([, value]) => {
      if (Array.isArray(value)) return true
      if (typeof value === 'string') return true
      return typeof value === 'boolean'
    }),
  )
}

export function customValuesFromProfile(values: ProfileFieldValue[]) {
  return Object.fromEntries(
    values.map((field) => {
      const key = String(field.custom_field_id)
      if (field.field_type === 'checkbox') return [key, field.value === true]
      if (field.field_type === 'multi-select') {
        return [key, Array.isArray(field.value) ? field.value.map(String) : []]
      }

      return [key, field.value == null ? '' : String(field.value)]
    }),
  )
}

export function stringValue(value: CustomFieldFormValue | undefined) {
  return typeof value === 'string' ? value : ''
}

export function customFieldInputType(fieldType: CustomFieldType) {
  switch (fieldType) {
    case 'date':
      return 'date'
    case 'number':
      return 'number'
    case 'URL':
      return 'url'
    default:
      return 'text'
  }
}

export function toggleCustomFieldChoice(
  selected: string[],
  choice: string,
  checked: boolean | 'indeterminate',
) {
  if (checked === true) return selected.includes(choice) ? selected : [...selected, choice]

  return selected.filter((candidate) => candidate !== choice)
}
